import { VirusScanStatus } from 'hb-react/shared/hooks/useGlobalStorageV2/constants';
import type { GlobalStorageFile } from 'hb-react/shared/hooks/useGlobalStorageV2/types';

export const isGSFileScanned = (storedFile: GlobalStorageFile) =>
  !!storedFile.virusScanStatus &&
  [
    VirusScanStatus.CLEAN,
    VirusScanStatus.INFECTED,
    VirusScanStatus.NOT_SCANNABLE,
  ].includes(storedFile.virusScanStatus);
